import axios from "axios";
import { Company } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_companies_company", async () =>
		(await axios.get<Company[]>(`/api/companies`, { params: { type: 'Company' } })).data
	);
